import { render, staticRenderFns } from "./providerWinLoseMemberTab.vue?vue&type=template&id=6bf1ad9c&lang=pug"
import script from "./providerWinLoseMemberTab.vue?vue&type=script&lang=js"
export * from "./providerWinLoseMemberTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports